import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import Routes from './Routes';
import {setCurrentUser} from './modules/auth/actions';

if (localStorage.athen_auth) {
    try {
        const auth = JSON.parse(localStorage.athen_auth);
        if (auth && auth.token) {
            const {login, pwdHash, remember, token} = auth;
            store.dispatch(setCurrentUser(login, pwdHash, token, remember));
        }
    } catch (err) {
    }
}

render(
    <Provider store={store}>
        <Routes />
    </Provider>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/